// Here we have some DOM-related utility functions.
// Please, check Vue.utils (https://github.com/vuejs/vue/blob/master/src/util/dom.js) before create new function here.

/**
 * Returns parents of given element (optionally includes element itself).
 * @param {Element} element - element to find parents for.
 * @param {boolean} includeSelf - flag that determines that result should include target element itself.
 * @returns {Array<Element>} - array of parent elements from target element to topmost parent.
 */
export function getParents (element, includeSelf = false) {
  const parents = []
  let parent = includeSelf ? element : element.parentNode
  while (parent != null) {
    parents.push(parent)
    parent = parent.parentNode
  }
  return parents
}



// WEBPACK FOOTER //
// ./src/shared/domUtils.js